import { Compass, Eye, Heart, Activity, Sparkles, Infinity as InfinityIcon } from "lucide-react";

// Single source of truth for the transformational journey.
// Each stage carries its own "why" — the reason it is a meaningful next step.
export const JOURNEY = [
  {
    n: "1",
    key: "descubrir",
    icon: Compass,
    title: "Descubrir",
    desc: "Reconocer tu historia y comprender desde dónde comienza tu recorrido.",
    why: "Todo empieza por verte con honestidad: reconocer tu historia y desde dónde comienza tu recorrido.",
    to: "/programs",
  },
  {
    n: "2",
    key: "comprender",
    icon: Eye,
    title: "Comprender",
    desc: "Identificar los patrones, creencias y respuestas que hoy influyen en tu vida.",
    why: "El siguiente paso es identificar los patrones, creencias y respuestas que hoy influyen en tu vida.",
    to: "/programs",
  },
  {
    n: "3",
    key: "sanar",
    icon: Heart,
    title: "Sanar",
    desc: "Trabajar con aquello que la comprensión revela, sin ocultarlo ni rechazarlo.",
    why: "Reconocer no basta; ahora trabajamos con aquello que la comprensión revela, sin ocultarlo ni rechazarlo.",
    to: "/programs",
  },
  {
    n: "4",
    key: "regular",
    icon: Activity,
    title: "Regular",
    desc: "Desarrollar recursos para recuperar seguridad interna y responder con mayor conciencia.",
    why: "Ahora desarrollas recursos para recuperar seguridad interna y responder con mayor conciencia.",
    to: "/programs",
  },
  {
    n: "5",
    key: "transformar",
    icon: Sparkles,
    title: "Transformar",
    desc: "Convertir lo aprendido en decisiones, hábitos y relaciones diferentes.",
    why: "Con bases firmes, conviertes lo aprendido en decisiones, hábitos y relaciones diferentes.",
    to: "/library",
  },
  {
    n: "6",
    key: "integrar",
    icon: InfinityIcon,
    title: "Integrar",
    desc: "Llevar el proceso a la vida cotidiana hasta convertirlo en una nueva forma de vivir.",
    why: "El cambio se vuelve permanente al llevar el proceso a la vida cotidiana como una nueva forma de vivir.",
    to: "/library",
  },
];

export const TOTAL_STAGES = JOURNEY.length;

export const getStage = (n) => JOURNEY.find((s) => s.n === String(n)) || null;

export const getNextStage = (n) => {
  const next = Number(n) + 1;
  return next <= TOTAL_STAGES ? getStage(next) : null;
};

// Why a given stage is a meaningful next step.
export const whyForStage = (n) => {
  const stage = getStage(n);
  if (!stage) return "Has recorrido las seis etapas; ahora tu práctica es vivir y compartir lo aprendido.";
  return stage.why;
};
